import React,{useEffect} from "react";
import Header from "./header";
import Footer from "./footer";
import { useSelector, useDispatch } from "react-redux";
import {getGenuinity} from "../state/action"
import { Link } from "react-router-dom";
export default function Genuinity(){

    const genuinity = useSelector((state) => state.gemstone.genuinity);
   
    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(getGenuinity());
    }, []);

return (
    
    <div>
         <Header />
             <section className="page-title centred" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1577883751617-803a40e0057b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1587&q=80)'}}>
  <div className="auto-container">
    <div className="content-box">
      <div className="title">
        <h1>Genuinity</h1>
      </div>
      <ul className="bread-crumb clearfix">
        <li>
            <Link to="/">Home</Link>
        </li>
        
      </ul>
    </div>
  </div>
</section>

      <section className="video-section" style={{backgroundImage:'url(https://images.unsplash.com/photo-1554917442-1899751d9286?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDN8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60)'}}>
  <div className="auto-container">
    <div className="row clearfix">
      <div className="col-lg-12 col-md-12 col-sm-12 left-column">
        <div className="content_block_7">
          <div className="content-box">
            <div className="sec-title dark" s>
              <p>Gemstones are a valuable piece of minerals, rocks, or organic matters that have been chosen
                and prized for their beauty, durability, and rarity and usually mined from the ground. They are
                precious jades that cut and polished to make jewelry or other ornaments.
                Most gemstones are hard, but some are too soft to be used in jewelry, so they are often
                exhibited in museums and sought by collectors. People tend to gravitate towards shiny objects.
                Gemstone have attracted human kind since ancient time.
                gemstones have been part of a jewellery since ancient times. However, the high demand in the
                market for gemstones has led to people being duped in to buying fake gemstones. The shine,
                great quality, luster may lure you into buying that seems real but probably fake gemstones.
                then how do we know if gemstones are real? </p>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-12 col-md-12 col-sm-12 right-column">
        <div className="content_block_8">
          <div className="content-box">
            <div className="text" >
              <p style={{color:"black"}}    >Below here is some ways to check if gemstones
                are real.</p>
            </div>
            <div className="inner-box">
                {genuinity.map((i)=>{
                    return (
                        <div className="single-item">
                      
                        <h4>{i.name}</h4>
                        <p>{i.description}</p>
                      </div>
                    )
                })}
             
            
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<Footer />
    </div>
)

}


  
     
     

     
  

        
